<template>
  <h2 :style="style"><slot/></h2>
</template>

<script>
import colors from '@/services/colors'

export default {
  name: 'TitleForm',
  
  computed: {
    style() {
      return {
        color: colors.blue
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-size: 40px;
  font-weight: 300;
  margin-bottom: 33px;
}
</style>
